<template>
  <div class="page-flexbox-wrapper" id="app">
    <router-view />
  </div>
</template>
<script>
import M from "materialize-css"; // eslint-disable-line
export default {};
</script>
<style src="@/assets/css/animate.css"></style>
<style lang="scss">
@import "~vue-snotify/styles/material";
.snotify-centerTop,
.snotify-centerCenter,
.snotify-centerBottom {
  left: calc(50% - 50% / 2) !important;
}
.snotify {
  width: 50% !important;
}
@media screen and (max-width: 1366px) {
  .snotify-centerTop,
  .snotify-centerCenter,
  .snotify-centerBottom {
    left: calc(50% - 80% / 2) !important;
  }
  .snotify {
    width: 80% !important;
  }
}
</style>
